import { createSlice } from "@reduxjs/toolkit";
import { getDishesListAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getDishesListSlice = createSlice({
  name: "getDishesList",
  initialState: data,
  reducers: {
   getDishesListSlice(state) {
      state.isLoading = true;
    },
   getDishesListSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getDishesListSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getDishesListSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getDishesListHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(getDishesListAction.getDishesListSlice());
    const response: any = await getDishesListAPI(id);
    
    dispatch(getDishesListAction.getDishesListSliceSuccess(response));
  } catch (e: any) {
    dispatch(getDishesListAction.getDishesListSliceFailure(e?.response?.data));
  }
};
export default getDishesListSlice.reducer;
export const getDishesListAction = getDishesListSlice.actions;
